import React from 'react'

function CostInput({ state, setState }) {
    return (
        <div className="col-sm-4 mb-3">
            <label className="form-label fw-bold" htmlFor="unp-extended-price">Cost per item</label>
            <div className="input-group"><span className="input-group-text"><i className="ci-dollar" /></span>
                <input
                    value={state.pricing.costPrice}
                    placeholder="10"
                    onChange={(e) => setState({ ...state, pricing: { ...state.pricing, costPrice: e.target.value } })}
                    className="form-control" type="text" id="unp-extended-price" autoComplete="off"
                />
            </div>
            <div className="form-text">Customers won’t see this.</div>
        </div>
    )
}

export default CostInput
